export default "__VITE_ASSET__BDJH7ohT__"